<div class="approval-flow-container" [class.compact]="compact">
  <div class="approval-steps" *ngIf="steps && steps.length > 0">
    <div
      *ngFor="let step of steps; let i = index; let isLast = last"
      class="step-wrapper"
    >
      <!-- 步驟節點 -->
      <div class="step-node-wrapper">
        <div
          class="step-node"
          [ngClass]="getStepNodeClass(step, i)"
          [title]="getStepTooltip(step, i)"
          [class.clickable]="isStepClickable(step, i)"
          [class.non-clickable]="!isStepClickable(step, i)"
          (click)="isStepClickable(step, i) && onStepClick(step, i)"
        >
          <span class="step-number">{{ i + 1 }}</span>
        </div>

        <!-- 步驟標籤 -->
        <div class="step-label" *ngIf="showLabels && !compact">
          <div class="step-name">{{ step.stepName || ('approval.step.step_number' | translate: {number: i + 1}) }}</div>
          <div class="step-approver">{{ getApproverNames(step, i) }}</div>
        </div>
      </div>

      <!-- 連接線（除了最後一個步驟） -->
      <div
        *ngIf="!isLast"
        class="step-connector"
        [ngClass]="getConnectorClass(step, steps[i + 1], i)"
      >
        <div class="connector-line"></div>
        <div class="connector-arrow">
          <i class="fas fa-chevron-right"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- 無簽核步驟時的顯示 -->
  <div class="no-steps" *ngIf="!steps || steps.length === 0">
    <span class="no-steps-text">{{ 'approval.flow.no_steps' | translate }}</span>
  </div>
</div>

<!-- 簽核狀態彈出視窗 -->
<div *ngIf="showApprovalStatus" class="approval-modal-overlay">
  <div class="approval-modal">
    <div class="modal-header">
      <h3>
        <i class="fas fa-pen-fancy"></i>
        {{ selectedFormName }} - {{ 'form.approval.approval_process' | translate }}
      </h3>
      <button class="close-button" (click)="closeApprovalStatus()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <app-approval-status
        [formId]="selectedFormId"
        [approvalFlow]="selectedapprovalflow"
        [stepIndex]="-1"
        [approvalResult]="approvalResult"
        [showCommentField]="true"
        [showSignatureField]="true"
        [signatureRequired]="false"
        (approvalComplete)="onApprovalComplete($event)">
      </app-approval-status>
    </div>
  </div>
</div>

<!-- 單一階段簽核彈出視窗 -->
<div *ngIf="showSingleStepApproval" class="approval-modal-overlay">
  <div class="approval-modal single-step-modal">
    <div class="modal-header">
      <h3>
        <i class="fas fa-pen-fancy"></i>
        {{ selectedFormName }} - {{ selectedStep?.stepName || ('步驟 ' + (selectedStepIndex + 1)) }}
      </h3>
      <button class="close-button" (click)="closeSingleStepApproval()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <!-- 階段資訊顯示 -->
      <!-- <div class="step-info-section">
        <div class="step-header">
          <div class="step-indicator">
            <div class="step-number">{{ selectedStepIndex + 1 }}</div>
            <div class="step-details">
              <h4>{{ selectedStep?.stepName || ('步驟 ' + (selectedStepIndex + 1)) }}</h4>
              <p class="step-approvers">
                <i class="fas fa-user"></i>
                簽核人員: {{ selectedStep?.approverName || '無指定人員' }}
              </p>
            </div>
          </div>
        </div>
        <div class="step-description">
          <p><i class="fas fa-info-circle"></i> 您正在對此階段進行簽核操作</p>
        </div>
      </div> -->

      <!-- 載入狀態 -->
      <div *ngIf="isSubmitting" class="loading-section">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p class="loading-text">正在提交簽核結果...</p>
      </div>

      <!-- 成功訊息 -->
      <div *ngIf="successMessage" class="success-message">
        <i class="fas fa-check-circle"></i>
        {{ successMessage }}
      </div>

      <!-- 錯誤訊息 -->
      <div *ngIf="errorMessage" class="error-message">
        <i class="fas fa-exclamation-circle"></i>
        {{ errorMessage }}
      </div>

      <!-- 簽核介面 -->
      <div [class.disabled]="isSubmitting">
        <app-approval-status
          [formId]="selectedFormId"
          [approvalFlow]="selectedapprovalflow"
          [stepIndex]="selectedStepIndex"
          [approvalResult]="approvalResult"
          [showCommentField]="true"
          [showSignatureField]="true"
          [signatureRequired]="false"
          (approvalComplete)="onApprovalComplete($event)">
        </app-approval-status>
      </div>
    </div>
  </div>
</div>
